import { render, staticRenderFns } from "./books-normal.vue?vue&type=template&id=72fc2e86&scoped=true&"
import script from "./books-normal.vue?vue&type=script&lang=js&"
export * from "./books-normal.vue?vue&type=script&lang=js&"
import style0 from "./books-normal.vue?vue&type=style&index=0&id=72fc2e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc2e86",
  null
  
)

export default component.exports